import {
  text,
  tac,
  pcHidden
} from './style'
import { Spacer } from 'components/Spacer'
import { Icon } from 'icons/Icon'

export const Timeout = () => {
  return (
    <div className={tac}>
      <Icon name="Cry" size={44} />
      <Spacer size={17}/>
      <p className={text}>
        ただいま混雑しております。<br />
        お時間をおいて<br className={pcHidden}/>
        再度お問い合わせください。
      </p>
    </div>
  );
}

